import React from "react";

import { Main, Page } from '../../../components/Sidebar';


export default function TaxDeductionPage({ sidebar }: any) {
    return (
        <Page>
            <Main close={sidebar} style={{marginRight:"25vw"}}>
                <div className="m-4">
                    <p className="text-left font-bold text-2xl">TAX DEDUCTION</p>
                </div>
            </Main>
            
        </Page>
    );
}
